"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ag_grid_react_1 = require("ag-grid-react");
var DataGrid = function (props) {
    return (react_1.default.createElement(ag_grid_react_1.AgGridReact, __assign({ rowSelection: "multiple", defaultColDef: {
            sortable: true,
            filter: true,
        } }, props)));
};
exports.default = DataGrid;
